import React, { useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import SpocAccordion from "./SpocAccordion";
import SpocAccordionSummary from "./SpocAccordionSummary";
import SpocAccordionDetails from "./SpocAccordionDetails";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 400,
    },
  })
);

interface CollapsableProps {
  heading: string;
  children: JSX.Element | Node | String;
  isOpen?: boolean;
  margin?: 1 | 2 | 3 | 4 | 5;
  id?: string;
}

const Collapsable = (props: CollapsableProps) => {
  const { children, heading, isOpen, margin = 4, id } = props;
  const classes = useStyles();
  const [expanded, setExpanded] = useState(() => {
    if (isOpen) return true;
    else return false;
  });

  const getMargins = (number = 4) => {
    return Array(number)
      .fill(number)
      .map((_, i) => i + 1);
  };

  return (
    <Box paddingY={getMargins(margin)} id={id ? id : undefined}>
      <Container>
        <SpocAccordion
          square
          expanded={expanded}
          onChange={() => setExpanded((prev) => !prev)}
          TransitionProps={{ unmountOnExit: true }}
        >
          <SpocAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="about-content"
            id="about-header"
          >
            <Typography className={classes.heading}>{heading}</Typography>
          </SpocAccordionSummary>
          <SpocAccordionDetails>{children}</SpocAccordionDetails>
        </SpocAccordion>
      </Container>
    </Box>
  );
};

export default Collapsable;
